import {
  useContext,
} from 'react';
import {Context} from '../contexts/WordList';
import {addCategory as addCategoryApi} from '../helpers/localApi';

export function useAddCategory(selectedKey, newCategory) {
  const [state, dispatch] = useContext(Context);
  const {language} = state;

  const addCategory = async (selectedKey, newCategory) => {
    if (selectedKey !== undefined && newCategory !== undefined) {
      try {
        const response = await addCategoryApi({
          language,
          id: selectedKey,
          category: newCategory,
        });

        dispatch({
          type: 'ADD_CATEGORY_TO_WORD',
          payload: {key: selectedKey, newTags: response.tags},
        });
      } catch (error) {
        console.error('Error adding category: ', error);
      }
    }
  };

  return {addCategory};
};
